import { IAuftrag } from "./IAuftrag";

export class Auftrag implements IAuftrag {
    
    auftragID: number;
    kostengruppeID: number;
    auftragsnummer: string;
    vertragsgegenstand: string;
    auftragsdatum?: Date;
    firmaID: number;
    firma: string;

    constructor(auftragID: number, kostengruppeID: number, auftragsnummer: string, vertragsgegenstand: string, firmaID: number, firma: string) {
        this.auftragID = auftragID;
        this.kostengruppeID = kostengruppeID;
        this.auftragsnummer = auftragsnummer;
        this.vertragsgegenstand = vertragsgegenstand;
        this.firmaID = firmaID;
        this.firma = firma;
    }
}
